export function slugifyProvider(value) {
  if (!value || typeof value !== "string") return "";
  return value
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function extractProvidersFromResponse(data) {
  if (!data) return [];
  const list = Array.isArray(data) ? data : data.providers ?? data.data ?? [];
  return Array.isArray(list) ? list : [];
}

export function normalizeProvider(provider) {
  const providerId = provider?.provider_id ?? provider?.id ?? provider?.providerId ?? "";
  const name = provider?.name ?? provider?.provider_name ?? provider?.title ?? "";
  const providerSlug = provider?.provider_slug ?? provider?.slug ?? slugifyProvider(name);
  const logo =
    provider?.logo?.url ??
    provider?.logo?.src ??
    provider?.provider_logo ??
    provider?.logo_url ??
    provider?.image_url ??
    provider?.provider_image ??
    provider?.provider_icon ??
    provider?.logo ??
    provider?.image ??
    provider?.icon ??
    "";
  const gameCount = provider?.gameCount ?? provider?.game_count ?? 0;

  return {
    ...provider,
    provider_id: providerId,
    name,
    provider_slug: providerSlug,
    logo,
    gameCount,
  };
}

export function isProviderEnabled(provider) {
  if (!provider || typeof provider !== "object") return false;

  const candidates = [
    provider.isEnabled,
    provider.is_enabled,
    provider.enabled,
    provider.provider_enabled,
    provider.active,
    provider.isActive,
    provider.is_active,
    provider.status,
  ];

  const normalize = (value) => {
    if (value === null || value === undefined) return null;
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
      const v = value.trim().toLowerCase();
      if (["1", "true", "yes", "enabled", "active"].includes(v)) return true;
      if (["0", "false", "no", "disabled", "inactive"].includes(v)) return false;
    }
    return null;
  };

  for (const candidate of candidates) {
    const resolved = normalize(candidate);
    if (resolved !== null) return resolved;
  }

  // If backend omitted explicit enabled flags, keep existing behavior.
  return true;
}

export function normalizeProviders(list) {
  if (!Array.isArray(list)) return [];
  return list
    .map(normalizeProvider)
    .filter((provider) => (provider.provider_id || provider.name) && isProviderEnabled(provider));
}

export function getProviderSlug(provider) {
  return provider?.provider_slug || slugifyProvider(provider?.name || "") || String(provider?.provider_id || "");
}

export function removeGroovePrefix(value) {
  if (!value || typeof value !== "string") return "";
  const normalized = value.toLowerCase().trim();
  const withoutPrefix = normalized.replace(/^groov(a|e)[-_]?/i, "").trim();
  return withoutPrefix.replace(/^[-_]+/, "");
}

export function getProviderDisplayName(provider) {
  const source =
    provider?.name || provider?.provider_slug || String(provider?.provider_id || "");
  const trimmed = removeGroovePrefix(source);
  if (!trimmed) return source;
  return trimmed.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}

export function resolveProviderBySlug(slug, providers) {
  if (!slug || !Array.isArray(providers)) return null;
  const target = String(slug).toLowerCase();
  return (
    providers.find((provider) => {
      const providerSlug = String(getProviderSlug(provider)).toLowerCase();
      const nameSlug = slugifyProvider(provider.name || "");
      const id = String(provider.provider_id || "");
      return providerSlug === target || nameSlug === target || id === target;
    }) || null
  );
}
